import { observable, action } from 'mobx';
import { toast } from 'react-toastify';

import { fetchShift, submitShift, copyShift } from '../api/shift';
import defaultFormatDate from '../utils/defaultFormatDate';
import pubSub from '../utils/pubSub';

export default class ShiftStore {
  @observable shift = {};

  @action
  fetchShift(id) {
    fetchShift(id)
      .then(this.fetchShiftSuccess)
      .catch(this.fetchShiftError);
  }

  @action.bound
  fetchShiftSuccess(res) {
    this.shift = res.data;
  }

  @action.bound
  fetchShiftError() {
    toast.error('Fout bij het ophalen van de ploeg');
  }

  @action
  closeShift() {
    this.shift = {};
  }

  @action
  submitShift(values) {
    return submitShift(values)
      .then(this.submitShiftSuccess)
      .then((res) => {
        pubSub.publish('fetch:day', this.shift.startDate);
        pubSub.publish('fetch:day', values.startDate);
        pubSub.publish('fetch:employees', values.startDate);
        return res;
      })
      .catch(this.submitShiftError);
  }

  @action.bound
  submitShiftSuccess() {
    toast.success('Ploeg opgeslagen');
  }

  @action.bound
  submitShiftError() {
    toast.error('Er is iets misgegaan bij het opslaan van een ploeg');
  }

  @action
  copyShift(shiftId, date) {
    return copyShift(shiftId, date)
      .then(this.copyShiftSuccess)
      .then(() => {
        pubSub.publish('fetch:day', defaultFormatDate(date));
      })
      .catch(this.copyShiftError);
  }

  @action.bound
  copyShiftSuccess() {
    toast.success('De ploeg is gekopieerd');
  }

  @action.bound
  copyShiftError() {
    toast.error('Fout bij het kopiëren van een ploeg');
  }
}



// WEBPACK FOOTER //
// ./src/store/shiftStore.js